import { productCodeIncludes } from '@/helpers/agencyProductCodes';
import { AgencyProduct, AgencyProductCodes } from '@/types-agency';

export const hasAccessToProspectionMap = (products: Array<AgencyProduct> | undefined): boolean =>
  !!products &&
  products.some((product) =>
    productCodeIncludes(product.productCode, [
      AgencyProductCodes.WELCOME,
      AgencyProductCodes.PROFESSIONAL,
      AgencyProductCodes.EXPERT,
    ]),
  );
